import { OFFER_LAND_TYPE, IOfferLand } from '../../types/offers';

export const getLandType = (land?: IOfferLand) => {
  if (land && land.status) {
    const type = OFFER_LAND_TYPE[land.status];

    return type ? type.toLowerCase() : '';
  }

  return '';
};
